module.exports = __webpack_public_path__ + "img/3.93b774b9.png";